import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { LocationArea } from '../../../../../../../models/location';
import { LocationService } from '../../../../../../../services/location/location.service';

@Component({
  selector: 'app-edit-location-area-modal',
  templateUrl: './edit-location-area-modal.component.html',
  styleUrls: ['./edit-location-area-modal.component.css']
})
export class EditLocationAreaModalComponent implements OnInit {

  @Input() locationArea: LocationArea;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public gymService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.gymService
      .updateLocationArea(this.locationArea)
      .then(updatedGymArea => {
        this.savedCallback({
          text: this.locationArea.name + ' saved successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit areas.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
